export default __webpack_public_path__ + "1df7a281505b8361ca277d4a718ccb59.svg";